var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6117 9.58666C20.6117 12.1336 18.547 14.1983 16 14.1983C13.453 14.1983 11.3883 12.1336 11.3883 9.58666C11.3883 7.03969 13.453 4.97498 16 4.97498C18.547 4.97498 20.6117 7.03969 20.6117 9.58666ZM26.1858 23.8059C26.6119 24.8346 26.8789 25.92 26.9796 27.025H5.02042C5.12106 25.92 5.38812 24.8346 5.8142 23.8059C6.36826 22.4683 7.18036 21.2529 8.20413 20.2292C9.2279 19.2054 10.4433 18.3933 11.7809 17.8392C13.1185 17.2852 14.5522 17 16 17C17.4478 17 18.8815 17.2852 20.2191 17.8392C21.5567 18.3933 22.7721 19.2054 23.7959 20.2292C24.8196 21.2529 25.6317 22.4683 26.1858 23.8059Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.d0c423837f0aa311f306ca7dd713485b.svg";
export { ForwardRef as ReactComponent };